<template>
  <div>
    <v-form ref="appeal-form" class="appeal-form" @submit.prevent="onSubmit">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate large />
      </v-overlay>


      <div class="appeal-form__section">
        <h3 class="appeal-form__section-title">
          {{ $t('appealInfo.status') }} - {{ getStatusName(appeal.status) }}
        </h3>
        <h3 class="appeal-form__section-title">
          {{ $t('appeals.category') }} - {{ getCategoryName(appeal.category) }}
        </h3>
        <h3 class="appeal-form__section-title">
          {{ $t('appealInfo.title') }}:
        </h3>
        <h4 class="appeal-form__section-title">
          {{ appeal.appeal }}
        </h4>
        <h3 class="appeal-form__section-title">
          {{ $t('appealInfo.chat') }}:
        </h3>
           <ul class="appeal-form__section-title">
              <li v-for="value in appeal.messages">
                 <h4 class="appeal-form__section-title">{{ value.user.name }}: {{ value.message }}</h4>
              </li>
           </ul>
        <div>
            <v-textarea
              v-if="appeal.status != 3"
              v-model="formData.response"
              no-resize
              :label="$t('appeals.response')"
            />
        </div>
      </div>
      <v-row class="d-flex align-end">
          <v-row> 
              <v-btn
                v-if="investor && appeal.status != 3"
                depressed
                type="button"
                class="appeal-form__submit mr-2"
                color="red lighten-1"
                @click="reject(3)"
              >
                {{ $t('common.button.complete') }}
              </v-btn>
              <v-btn
                v-if="appeal.status != 3"
                type="submit"
                class="appeal-form__submit mr-5"
                color="warning"
                elevation="0"
              >
                {{ $t('common.btns.send_message') }}
              </v-btn>
          </v-row>
      </v-row>
    </v-form>


    <v-snackbar v-model="snack.value" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </div>
</template>

<script>

import isInvestor from '@/helpers/isInvestor';

export default {
  props: {
    appealId: [String, Number],
  },
  components: {
  },
  data: () => ({
    loading: false,
    investor: false,
    appeal: {},
    dateTimeDialog: {
      opened: false,
      param: '',
    },
    snack: {
      value: false,
      message: '',
      color: '',
    },
    formData: {
      response: '',
    },
  }),
  computed: {
    statuses() {
      return this.$store.state.appeals.statuses;
    },
    categories() {
      return this.$store.state.appeals.categories;
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },

    async onSubmit() {
      const isValid = this.$refs['appeal-form'].validate();

      if (!isValid) {
        window.scrollTo(0, 0);
        return;
      }

      this.loading = true;
      let id = this.appealId;
      let params = this.formData;
      const { success } = await this.$store.dispatch(
        'appeals/sendMessage', { id, params }
      );
      
      const snack = {
        value: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (!success) {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      } else {
        setTimeout(() => {
          //this.$router.push('/appeals');
          location.reload();
        }, 1500);
      }

      this.snack = snack;
      this.loading = false;
    },
    
    getStatusName(id) {
      const status = this.statuses.find((item) => item.id === id);
      return status ? status.name : '';
    },
    
    getCategoryName(id) {
      const category = this.categories.find((item) => item.id === id);
      return category ? category.name : '';
    },
    
    async reject(status) {
      this.loading = true;
      let id = this.appealId;
      let params = { status };
      const { success } = await this.$store.dispatch(
        'appeals/updateItem', { id, params }
      );
      
      const snack = {
        value: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (!success) {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      } else {
        setTimeout(() => {
          this.$router.push('/appeals');
        }, 1500);
      }

      this.snack = snack;
      this.loading = false;
    },
  },
  async created() {
    if (!this.statuses.length) {
      this.loading = true;
      await this.$store.dispatch('appeals/fetchStatuses');
      this.loading = false;
    }
    if (!this.categories.length) {
      this.loading = true;
      await this.$store.dispatch('appeals/fetchCategories');
      this.loading = false;
    }
    if (!this.appeal.length) {
      this.loading = true;
      const data = await this.$store.dispatch('appeals/fetchItem', this.appealId);
      this.appeal = data;
      this.loading = false;
    }
    if (isInvestor()) {
        this.investor = true;
    }
  },
};
</script>

<style lang="scss">
.appeal-form {
  margin-top: 30px;
  padding-bottom: 20px;

  &__section {
    display: flex;
    flex-wrap: wrap;

    &-title {
      max-width: 100% !important;
      margin-top: 15px;
      margin-bottom: 15px;
      color: #464646;
    }

    > * {
      margin-right: 30px;
    }

    > *,
    .v-input {
      width: 100%;
      max-width: 300px;
    }
  }

  &__submit {
    display: block;
    max-width: 250px;
    width: 100%;
    margin-top: 30px;
  }

  .v-text-field__slot input,
  .v-select__slot input {
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
</style>
